/* eslint eqeqeq: 0 */
import React, { Component } from "react";
function computeHeight(node) {
    let css = getComputedStyle(node);
    const totalHeight = parseInt(css.height ? css.height : '0', 10);
    const padding = parseInt(css.paddingTop ? css.paddingTop : '0', 10) +
        parseInt(css.paddingBottom ? css.paddingBottom : '0', 10);
    return totalHeight - padding;
}
function getAutoHeight(n) {
    if (!n) {
        return 0;
    }
    let node = n;
    let height = computeHeight(node);
    while (!height) {
        if (node.parentNode) {
            node = node.parentNode;
            height = computeHeight(node);
        }
        else {
            break;
        }
    }
    return height;
}
function autoHeight() {
    return (WrappedComponent) => class extends Component {
        constructor() {
            super(...arguments);
            this.state = {
                computedHeight: 0,
            };
            this.handleRoot = (node) => {
                this.root = node;
            };
        }
        componentDidMount() {
            const { height } = this.props;
            if (!height) {
                const h = getAutoHeight(this.root);
                // eslint-disable-next-line
                this.setState({ computedHeight: h });
            }
        }
        render() {
            const { height } = this.props;
            const { computedHeight } = this.state;
            const h = height || computedHeight;
            return (React.createElement("div", { ref: this.handleRoot }, h > 0 && React.createElement(WrappedComponent, Object.assign({}, this.props, { height: h }))));
        }
    };
}
export default autoHeight;
